import React from "react";
const KS2SeactionAHeader = () => {
  return (
    <div className="row  section-box">
      <div className="personal-details">
        <div className="form-check disabled pl-1">
          <input className="form-check-input " type="radio" disabled style={{ marginRight: "15px" }} />
          <label className="kr-title form-check-label pl-3 pr-4">Section A</label>
        <span className="title pr-1">General</span>
          <label className="form-check-label blockletterrs-use pr-2">Please put a X to indicate your situation eg &nbsp;&nbsp;</label>
          <input className="cross-textbox" type="text" value="X" disabled />
        </div>
      </div>
    </div>
  );
};
export default KS2SeactionAHeader;
